var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.items),function(item,index){return _c('div',{staticClass:"tab",class:{active : _vm.isActive === index},on:{"click":function($event){return _vm.tab(index)}}},[_vm._v("\n        "+_vm._s(item)+"\n      ")])}),0),_vm._v(" "),_c('div',[_c(_vm.test,{tag:"component"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d7748b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 